module.exports = __webpack_public_path__ + "vector_laptop.svg?2c11b44567815a0f756216f0976c9bbd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vector_laptop.svg
// module id = 453
// module chunks = 0